import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getAllPatients = (clinicId, pageNo = 0, pageSize = 20, query = '') => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    if (query) {
        params.set('q', query);
    }

    return axios.get(`${API_URL}clinics/${clinicId}/patients?${params.toString()}`);
};

const getPatientById = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId) 
}
const updatePatientDetails = (clinicId,patientId,data) =>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId,data)
}
const getCommunicationPreferences = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/comm-prefs")
}

const updateCommunicationPreferences = (clinicId,patientId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/comm-prefs",data)
}

const getPatientInvalidDetails = (clinicId,patientId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/invalid-details")
}

const getInvalidDetailsList = (clinicId, pageNo = 0, pageSize = 20, query = '') => {
    const params = new URLSearchParams({
        no: String(pageNo),
        size: String(pageSize),
    });

    if (query) {
        params.set('q', query);
    }

    return axios.get(`${API_URL}clinics/${clinicId}/invalid-details?${params.toString()}`);
};

const deleteInvalidDetails = (clinicId, detailIds, patientId = null) => {
    const url = patientId
        ? `${API_URL}clinics/${clinicId}/patients/${patientId}/invalid-details`
        : `${API_URL}clinics/${clinicId}/invalid-details`;

    return axios.delete(url, { data: detailIds });
};

const updatePatientInvalidDetails = (clinicId,patientId,data)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/invalid-details",data)
}
const getPatientAppointments = (clinicId, patientId, pageNo = 0, pageSize = 20) => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    return axios.get(`${API_URL}clinics/${clinicId}/patients/${patientId}/appointments?${params.toString()}`);
};

const getPatientActivities = (clinicId, patientId, pageNo = 0, pageSize = 20) => {
    const params = new URLSearchParams({
        no: String(pageNo),
        size: String(pageSize),
    });

    return axios.get(`${API_URL}clinics/${clinicId}/patients/${patientId}/activity?${params.toString()}`);
};

const previewPatientEmail = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/preview`, payload);
};

const sendPatientEmail = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email`, payload);
};

const previewPatientSms = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms/preview`, payload);
};

const sendPatientSms = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms`, payload);
};

const previewPatientThankYouEmail = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/thank-you/preview`, payload);
};

const sendPatientThankYouEmail = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/thank-you`, payload);
};

const previewPatientThankYouSms = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms/thank-you/preview`, payload);
};

const sendPatientThankYouSms = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms/thank-you`, payload);
};

const previewPatientWelcomeEmail = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/welcome/preview`, payload);
};

const sendPatientWelcomeEmail = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/welcome`, payload);
};

const previewPatientWelcomeSms = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms/welcome/preview`, payload);
};

const sendPatientWelcomeSms = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms/welcome`, payload);
};

const previewPatientGlassPickupEmail = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/glass-pickup/preview`, payload);
};

const sendPatientGlassPickupEmail = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/glass-pickup`, payload);
};

const previewPatientGlassPickupSms = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms/glass-pickup/preview`, payload);
};

const sendPatientGlassPickupSms = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms/glass-pickup`, payload);
};

const previewPatientLensPickupEmail = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/lens-pickup/preview`, payload);
};

const sendPatientLensPickupEmail = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/lens-pickup`, payload);
};

const previewPatientLensPickupSms = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms/lens-pickup/preview`, payload);
};

const sendPatientLensPickupSms = (clinicId, patientId, payload = {}) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/sms/lens-pickup`, payload);
};

const previewPatientArticleEmail = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/articles/preview`, payload);
};

const sendPatientArticleEmail = (clinicId, patientId, payload) => {
    return axios.post(`${API_URL}clinics/${clinicId}/patients/${patientId}/send/email/articles`, payload);
};

const getCampaignPatients = (
    clinicId,
    {
        pageNo = 0,
        pageSize = 20,
        query = '',
        mediumType = 'sms',
        type = 'blast',
    } = {}
) => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
        mediumType,
        type,
    });

    if (query) {
        params.set('q', query);
    }

    return axios.get(`${API_URL}clinics/${clinicId}/campaigns/patients?${params.toString()}`);
};

const patientService = {
    getAllPatients,
    getCampaignPatients,
    getPatientById,
    updatePatientDetails,
    getCommunicationPreferences,
    updateCommunicationPreferences,
    getPatientInvalidDetails,
    getPatientInvalidData: getPatientInvalidDetails,
    getInvalidDetailsList,
    deleteInvalidDetails,
    deletePatientInvalidData: deleteInvalidDetails,
    updatePatientInvalidDetails,
    getPatientAppointments,
    getPatientActivities,
    previewPatientEmail,
    sendPatientEmail,
    previewPatientSms,
    sendPatientSms,
    previewPatientThankYouEmail,
    sendPatientThankYouEmail,
    previewPatientThankYouSms,
    sendPatientThankYouSms,
    previewPatientWelcomeEmail,
    sendPatientWelcomeEmail,
    previewPatientWelcomeSms,
    sendPatientWelcomeSms,
    previewPatientGlassPickupEmail,
    sendPatientGlassPickupEmail,
    previewPatientGlassPickupSms,
    sendPatientGlassPickupSms,
    previewPatientLensPickupEmail,
    sendPatientLensPickupEmail,
    previewPatientLensPickupSms,
    sendPatientLensPickupSms,
    previewPatientArticleEmail,
    sendPatientArticleEmail,
}

export default patientService